import { push } from 'redux-first-history';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { doesInclude } from '../../Util';
import { SingleInput } from '@imprivata/nucleus';
import headerImage from '../../images/tempIcon.svg';
import MoreOptions from '../shared/MoreOptions';
import LogoutStyled from '../shared/LogoutStyled';
import * as actions from '../../actions';


/**
 * TempCode Component
 */
export class TempCode extends Component {
  /**
   * The allowed properties for the TempCode component
   * @param {function} verifyTempCode verify the temporary token code given to the user
   * @param {bool} isLoading is something on the page loading?
   * @param {array} availableModalities available modalities to switch to
   */

  static propTypes = {
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    capabilities: PropTypes.object,
    isDeviceManagementWorkflow: PropTypes.bool,
    isLoading: PropTypes.bool,
    verifyTempCode: PropTypes.func.isRequired,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
  };

  static defaultProps = {
    availableModalities: [],
    authenticatedModalities: [],
    capabilities: {},
    isDeviceManagementWorkflow: false,
    useCustomUX: false,
  };

  submit = state => {
    this.props.verifyTempCode(state.tokenCode);
  };

  // builds list for capabilitiesToRender
  buildCapabilityList = capability => {
    let capabilityList = '';
    capabilityList = capabilityList.concat(capability);
    return capabilityList;
  };

  render() {
    const {
      availableModalities,
      capabilities,
      isLoading,
      selfServiceEnabled,
      serverState,
      startDeviceManagementWorkflow,
      useCustomUX,
      username,
      allowEditUsername,
    } = this.props;

    // variables
    let capabilitiesToRender = '';
    let moreOptions = null;
    const moreOptionsMainMarkup = <MoreOptions currentModality='tempcode' />;
    const moreOptionsAltMarkup = <div className='Temp-code-text'>Alternatively, call your help desk for a temp code</div>;

    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'tempcode') : [];
    const hasTempCodeMessage = serverState && serverState.temporaryCodeAllowed && !serverState.temporaryCodeAvailable;
    const modalitiesPresent = modalities.length > 0;
    const logoutStyle = useCustomUX ? 'black' : 'white';

    // rendering the more options markup
    modalitiesPresent && (moreOptions = moreOptionsMainMarkup);
    (hasTempCodeMessage && !modalitiesPresent) && (moreOptions = moreOptionsAltMarkup);

    // enroll device link composition
    const createEnrollDeviceLink = () => (
      !this.props.isDeviceManagementWorkflow
      && doesInclude(capabilitiesToRender, 'enroll')
      && doesInclude(availableModalities, 'iid')
      && selfServiceEnabled
    ) ? startDeviceManagementWorkflow : null;

    // Check if Fortuna
    try {
      capabilitiesToRender = capabilities.DeviceManagement[0].functions.map(this.buildCapabilityList);
    }
    catch (error) {
      try {
        // Check if Europa
        if (capabilities.DeviceManagement.version != null) {
          capabilitiesToRender = 'enroll';
        }
      }
      catch (error) {
        capabilitiesToRender = '';
      }
    }

    return (
      <div className='content-body'>
        <SingleInput
          autoFocus={true}
          enrollDeviceLink={createEnrollDeviceLink()}
          headerDescription='Enter code provided by your help desk'
          headerImage={headerImage}
          headerTitle='Temporary code'
          inputMask={false}
          inputType='text'
          isLoading={isLoading}
          logoutComponent={<LogoutStyled type={logoutStyle} />}
          moreOptionsLink={moreOptions}
          onInputChange={this.inputChange}
          onSubmit={this.submit}
          placeholderText='Temporary code'
          retryText=''
          submitText='Confirm your identity'
          useCustomUX={useCustomUX}
          username={username}
          allowEditUsername={allowEditUsername}
          resetUsername={this.props.reset}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    isLoading, availableModalities, serverState, capabilities, isDeviceManagementWorkflow, selfServiceEnabled, useCustomUX,
    username, isClinicalWorkflow, allowEditUsername,
  } = state.login;
  return {
    isLoading,
    availableModalities,
    serverState,
    capabilities,
    isDeviceManagementWorkflow,
    selfServiceEnabled,
    useCustomUX,
    username,
    allowEditUsername,
    isClinicalWorkflow,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    viewDeviceList: () => {
      dispatch(push('/devicelist') );
    },
    verifyTempCode: token => {
      dispatch(actions.verifyTempCode(token) );
    },
    startDeviceManagementWorkflow: () => {
      dispatch(actions.startDeviceManagementSession() );
      dispatch(actions.startIgnoreTimeout() );
      dispatch(actions.moreOptionsChooseModality(false) );
      dispatch(push('/choosemodality') );
    },
    returnToChooseModality: () => {
      dispatch(actions.moreOptionsChooseModality(true) );
      dispatch(push('/choosemodality') );
    },
    reset: () => {
      dispatch(actions.reset() );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TempCode);
